import { FILTER_TYPE_TEXT, FILTER_TYPE_MULTISELECT, FILTER_TYPE_DATETIME } from "@/store/system/helpers";
import store from "@/store";

export function getBlankCriteria() {
  return {
    id: null,
    fromDate: null,
    toDate: null,
    action: [],
    userName: null,
    description: null
  };
}

export function getSearchFilters(actionsFilter, excludeDescription) {
  const allActions = store.state.lookups.data.systemLogActions;
  const actions = actionsFilter ? allActions.filter(a => a.attributes.includes(actionsFilter)) : allActions;
  const filters = [];
  filters.push({
    text: "Action",
    value: "action",
    type: FILTER_TYPE_MULTISELECT,
    items: actions,
    width: excludeDescription ? 8 : 12
  });
  if (!excludeDescription) {
    filters.push({ text: "Description", width: 8, value: "description", type: FILTER_TYPE_TEXT });
  }
  filters.push({ text: "User name", width: 4, fat: excludeDescription, value: "userName", type: FILTER_TYPE_TEXT });
  filters.push({ text: "From", width: 6, value: "fromDate", type: FILTER_TYPE_DATETIME });
  filters.push({ text: "To", width: 6, value: "toDate", type: FILTER_TYPE_DATETIME });
  return filters;
}
